import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../Service/app-service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,
    FormsModule, RouterModule, NgbModule,],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  showNewPassword: boolean = false;
  confirmPasssword: boolean = false;
  newPasswordDisplay: boolean = false;
  toBeEditedTagId: any;
  statusChangeText: any;
  changePasswordForm!: FormGroup;
  passwordErrorMessage: string = '';
  openConfirmChnagePopup: boolean = false;
  user: any;
  errorMessage!: string;
  userId!: number;
  successMessage: string = '';
  constructor(private authService: AuthService, private modalService: NgbModal, private router: Router, private fb: FormBuilder) {
  }
  ngOnInit() {
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required,],
      newPassword: ['', [
        Validators.required,
        Validators.pattern('(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}'),
        this.differentFromOldPasswordValidator('oldPassword')
      ]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.mustMatch('newPassword', 'confirmPassword') });
    this.getUserIdFromStorage();
  }
  onCancel1(): void {
    this.changePasswordForm.reset();
    this.modalService.dismissAll();
    this.passwordErrorMessage = '';
    this.successMessage = '';
  }
  getUserIdFromStorage(): void {
    const userData = sessionStorage.getItem('userId');
    if (userData) {
      const { userId, expirationTime } = JSON.parse(userData);

      // Check if the stored data is still valid (not expired)
      if (new Date().getTime() < expirationTime) {
        this.userId = userId;
        this.getUserData(userId);
      } else {
        sessionStorage.removeItem('userId');  // Remove expired data
        console.log('User ID data expired');
      }
    } else {
      console.log('No user ID found in session storage');
    }
  }

  getUserData(userId: number): void {
    this.authService.getUserById(userId).subscribe({
      next: (userData) => {
        this.user = userData;
        console.log('Fetched User Data:', this.user);
      },
      error: (error) => {
        console.error('Error fetching user data:', error);
        this.errorMessage = 'Error fetching user data';
      }
    });
  }
  openAddForm(content: any) {
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }
  closeModal(): void {
    // Logic to close the modal
    console.log('Modal closed');
  }
  get oldPassword() {
    return this.changePasswordForm.get('oldPassword');
  }

  get newPassword() {
    return this.changePasswordForm.get('newPassword');
  }

  get confirmPassword() {
    return this.changePasswordForm.get('confirmPassword');
  }

  differentFromOldPasswordValidator(oldPasswordControlName: string) {
    return (control: any) => {
      const formGroup = control?.parent;
      if (!formGroup) {
        return null;
      }

      const oldPassword = formGroup.get(oldPasswordControlName)?.value;
      const newPassword = control.value;

      if (oldPassword && newPassword === oldPassword) {
        return { sameAsOldPassword: true }; // Custom error
      }

      return null;
    };
  }
  // Custom validator to check if newPassword and confirmPassword match
  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.get(controlName);
      const matchingControl = formGroup.get(matchingControlName);

      if (matchingControl?.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      if (control?.value !== matchingControl?.value) {
        matchingControl?.setErrors({ mustMatch: true });
      } else {
        matchingControl?.setErrors(null);
      }
    };
  }
  onSubmit(): void {
    if (this.changePasswordForm.valid) {
      const { oldPassword, newPassword } = this.changePasswordForm.value;

      const requestBody = {
        userId: this.userId.toString(),
        oldPassword: oldPassword,
        newPassword: newPassword
      };

      this.authService.changePassword(requestBody).subscribe(
        (response) => {
          this.successMessage = 'Password changed successfully!';
          setTimeout(() => {
            this.clearAuthToken();
            this.modalService.dismissAll();
            this.router.navigate(['/login']);
          }, 3000);
        },
        (error) => {
          console.error('Error changing password', error);
          this.passwordErrorMessage = 'Current password is incorrect';
        }
      );
    }
  }

  preventSpace(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }

  clearAuthToken(): void {
    sessionStorage.removeItem('authToken');
  }
  onCancel(): void {
    this.changePasswordForm.reset();
    this.passwordErrorMessage = '';
    this.successMessage = '';
  }

  logout(modal: any): void {
    this.authService.clearAuthToken();
    this.modalService.dismissAll();
    this.router.navigate(['/login']).then(() => {
      this.showToast('Logout successful!');
      modal.close('Logout confirmed');
    });
  }
  showToast(message: string): void {
    // Create toast element
    const toast = document.createElement('div');
  
    // Add tick mark and message
    toast.innerHTML = `
      <span style="color: white; font-weight: bold;margin-left: 100px; margin-right: 10px;">&#10004;</span>
      <span>${message}</span>
    `;
  
    // Apply styles for green toast at the top-right
    Object.assign(toast.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      width: '400px',
      backgroundColor: '#4CAF50', // Green background
      color: 'white',
      padding: '12px 24px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      zIndex: '1000',
      opacity: '0',
      transform: 'translateX(20px)',
      transition: 'opacity 0.5s ease, transform 0.5s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start', // Tick and message aligned left
    });
  
    // Append toast to body
    document.body.appendChild(toast);
  
    // Make toast visible
    setTimeout(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(0)';
    }, 0);
  
    // Remove toast after 3 seconds
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(20px)';
      setTimeout(() => document.body.removeChild(toast), 500);
    }, 3000);
  }
  
}

